__turbopack_context__.v({
  "container": "styles-module__eFliZW__container",
  "icon": "styles-module__eFliZW__icon",
});
